<template>
    <div class="container-fluid">
        <div class="row">      
            <Navbar :class="[mobile?'navbar-admin':'navbar-admin-mobile']" v-show="toggle"></Navbar>
            <div  :class="{ 'col-lg-12': !toggle }"  class="col-lg-9 col-md-12 col-xs-12">
              <div class="container">
   
                <Controls></Controls>
                
                <!--
                <Controls2></Controls2>
                -->


                  <!--seccion pasos-->
                  <div class="row">
                      <div class="col-12">
                        <button class="btn btn-default btn-custom-fixed" @click='toggle = !toggle'> 
                          <font-awesome-icon v-show="toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-left']" /> 
                          <font-awesome-icon v-show="!toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-right']" /> 
                        </button>

                        <button class="d-xl-none btn btn-default btn-custom-fixed-mobile" @click='mobile = !mobile'> 
                          <font-awesome-icon style="z-index:2;"  :style="{ color: '#FFFFFF', position: 'absolute', left: '3', top: '2' }" size="2x" :icon="['fas', 'bars']" /> 
                        </button>

                        <div class="container mt-2">
                            <div class="row">
                            <div class="col-md-12 col-sm-12">
                              <center>
                                <h1 v-if="iso639_1 === 'es'">Cambiar contraseña</h1>
                                <h1 v-else>Change Password</h1>
                              </center>
                                    <div class="form-group">
                                        <label v-if="iso639_1 === 'es'" class="title-form">Contraseña actual</label>
                                        <label v-else class="title-form">Current password</label> 
                                        <input v-model="user.contrasena" type="password" class="form-control  btn-sombra">
                                    </div>

                                    <div class="form-group">
                                        <label v-if="iso639_1 === 'es'" class="title-form">Nueva contraseña</label> 
                                        <label v-else class="title-form">New Password</label>
                                        <input v-model="user.contrasenan" type="password" class="form-control  btn-sombra" >
                                    </div>

                                    <div class="form-group">
                                        <label v-if="iso639_1 === 'es'" class="title-form">Repetir nueva contraseña</label> 
                                        <label v-else class="title-form">Repeat new password</label>
                                        <input v-model="user.contrasenar" type="password" class="form-control  btn-sombra">
                                    </div>                                                                        

                                    <button v-if="iso639_1 === 'es'" @click="actualizarPassword(user)" class="form-control" type="submit">Guardar</button>
                                    <button v-else @click="actualizarPassword(user)" class="form-control" type="submit">Save</button>

                                </div>
                               
                            </div>
                          <hr>
                        </div>
                        <div class="spacing"></div>   


                      </div>
                  </div>
                  <!--fin seccion inputs-->
              </div>
            </div>
        </div>    
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import Navbar from '@/components/Navbar.vue'
import Controls from '@/components/Controls.vue'

export default {
  name: 'CambiarContrasena', 
  components: {
    Navbar,
    Controls
  },
  data() {
    return {
     toggle: true,
     mobile : true,
     user:{
      contrasena: '',
      contrasenan: '',
      contrasenar: ''
     }
    }
  },
  methods:{
    ...mapActions(['actualizarPassword'])
  },
  computed:{
    ...mapState(['language', 'iso639_1'])
  },   
  created(){

  }
}
</script>




<style scoped>
.dot {
  height: 25px;
  width: 25px;
   background-color: #F7F7F7;
  border-radius: 50%;
  display: inline-block;
  border: 1px;
  color: #5A287F;
  border-style: solid;
  border-width: 1px;
  border-color:#5A287F;
}
.btn-custom-fixed{
   background-color:#5A287F;
   color:white;
   width: 35px; 
   height: 60px;
   position: absolute;
   left: -50px;
   top: 60px;
}

@media (max-width: 991px) {
  .btn-custom-fixed{
   display: none;
  }
}

.opt-active{
  background-color: #5A287F;
  color: #FFFFFF;
  border-radius: 0;
}

.total{
  background-color: #5A287F;
  position: absolute;
  top:150px;
  width: auto;
}

.card-footer{
    background-color: #5A287F;
    color:white;
}

.recibe{
    background-color: #5A287F;
    color:white;
}

.circulo {
     width: 20px;
     height: 20px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: #A2C037;
}

.circulo-red {
     width: 20px;
     height: 20px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: #FF5353;
}
</style>


